import React, { Fragment, PureComponent } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { formatDate } from "../../../../../helpers/dateHelpers";
import { formatShipmentStatus } from "../../../../../helpers/shipmentStatusHelpers";
import ListPopover from "../../../../Layout/SortedList/ListPopover";

class ShipmentStatusCell extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    dateDisplayFormat: PropTypes.string,
    header: PropTypes.string,
    loadShipmentStatus: PropTypes.object
  };

  static defaultProps = {
    className: "",
    header: "",
    loadShipmentStatus: {},
    dateDisplayFormat: ""
  };

  state = {
    isContentVisible: false
  };

  maybeOverflowedRef = React.createRef();

  handleToggleIsContentVisible = () => {
    if (this.maybeOverflowedRef.current.offsetWidth + 1 < this.maybeOverflowedRef.current.scrollWidth) {
      this.setState({ isContentVisible: !this.state.isContentVisible });
    }
  };

  renderStatusPopover = () => {
    return (
      <Fragment>
        <ListPopover label={this.props.loadShipmentStatus.statusValue} contentText={this.props.loadShipmentStatus.contactName} mouseOver /> -{" "}
        {formatDate(this.props.loadShipmentStatus.date, this.props.dateDisplayFormat)}
      </Fragment>
    );
  };

  render() {
    const isStatusNotBooked = this.props.loadShipmentStatus.statusCode !== "Booked";

    return (
      <div
        className={classNames("sorted-list__data", this.props.className)}
        onMouseEnter={this.handleToggleIsContentVisible}
        onMouseLeave={this.handleToggleIsContentVisible}
        ref={this.maybeOverflowedRef}>
        {this.props.header && <span className="sorted-list__data-header">{this.props.header}</span>}

        {isStatusNotBooked ? formatShipmentStatus(this.props.loadShipmentStatus, this.props.dateDisplayFormat) : this.renderStatusPopover()}

        {this.state.isContentVisible && (
          <span className="list-popover__content">{formatShipmentStatus(this.props.loadShipmentStatus, this.props.dateDisplayFormat)}</span>
        )}
      </div>
    );
  }
}

export default ShipmentStatusCell;



// WEBPACK FOOTER //
// ./src/components/PurchaseOrder/OrderPage/List/Loads/ShipmentStatusCell.js